import { SubmitApplicationOk } from './types';

export type MockSubmitType = 'APPROVED' | 'REJECTED' | 'MANUAL_INSPECTION' | 'VALIDATION_ERROR' | 'SERVER_ERROR';

export const mockService = {
    submit(mockType: MockSubmitType): Promise<SubmitApplicationOk> {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (mockType === 'VALIDATION_ERROR') {
                    return reject({ type: 'ValidationError', message: '✖ Invalid input: expected number, received NaN → at amount' });
                }
                if (mockType === 'SERVER_ERROR') {
                    return reject({ type: 500, message: 'Något gick fel, vänligen försök igen.' });
                }

                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const mockDecisionMap: Record<Exclude<MockSubmitType, 'VALIDATION_ERROR' | 'SERVER_ERROR'>, any> = {
                    APPROVED: 'APPROVED',
                    REJECTED: 'REJECTED',
                    MANUAL_INSPECTION: 'MANUAL_INSPECTION',
                };

                const isApproved = mockType === 'APPROVED';

                resolve({
                    status: 'ok',
                    result: {
                        submitApplicationExtResult: {
                            applicationReference: '12345',
                            decision: mockDecisionMap[mockType],
                            approvedAmount: 175000,
                            interest: 12.5,
                            tenor: 48,
                            effectiveInterest: 13.98,
                            monthlyCost: 4755,
                            consolidationDemand: 17500,
                            adminFee: 59,
                            arrangementFee: 0,
                            documentTypes: ['ID', 'PAYMENT_SLIP'],
                            totalRepaymentAmount: 228215,
                            monthlyAccountFee: 0,
                            totalFeesAndInterest: 53215,
                        },
                    },
                    acceptQuoteResult: isApproved
                        ? {
                              status: 'ok',
                              result: {
                                  acceptQuoteResult: {
                                      accepted: true,
                                      message: 'Offer accepted',
                                  },
                              },
                          }
                        : null,
                });
            }, 800);
        });
    },
};
